import { render, staticRenderFns } from "./RecognizerSettingForm.vue?vue&type=template&id=450f4b63&scoped=true&"
import script from "./RecognizerSettingForm.vue?vue&type=script&lang=js&"
export * from "./RecognizerSettingForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "450f4b63",
  null
  
)

export default component.exports